import React, { useState } from "react";
import { useEffect } from "react";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { DeletePenaltyconfigById, getPenaltybyPageSize } from "../../../AdminActionCreator.component";
import AddEditLendor from "./AddEditOverdue";
import { Pagination } from "@mui/material";
import Nodata from '../../../../../../images/nodata.png'
import ConfirmationPopup from '../../../../../presentationals/Popup/ConfirmationPopup.component'
import PopUp from "../../../../../presentationals/Popup/Popup.component";
import Loader from '../../../../../presentationals/Loader/Loader.component'
import moment from "moment";

const size = 10;
const Projections = ({ admin }) => {
    const [loader, setLoader] = useState(false)
    const [openAccordion, setOpenAccordion] = useState(null);
    const [dayWiseApiData, setdayWiseData] = useState('');
    const [apiData, setApiData] = useState([]);
    const [editMode, setEditMode] = useState('tableView')
    const [editData, setEditData] = useState({})
    const [confirmPopup, setconfirmPopup] = useState(false)
    const [deleteData, setDeleteData] = useState({})
    const [popupStatus, setpopupStatus] = useState('')
    const [popupstate, setPopupState] = useState(false)
    const [addType, setaddType] = useState('add')
    const [currentPage, setcurrentPage] = useState(1)
    const [totalItems, setTotalItems] = useState(0)

    const toggleAccordion = (id) => {
        setOpenAccordion(openAccordion === id ? null : id);
    };
    const handlebtnclick = (type, data) => {
        if (type == 'add' || type == 'edit') {
            setEditMode('Editable')

            setaddType(type)

            setEditData(data)
        } else if (type == 'delete') {
            setconfirmPopup(true)
            setDeleteData(data)
        }
    }
    const handleSavebtn = () => {
        setEditMode('tableView')
        setcurrentPage(1)
        getData(1)
    }

    useEffect(() => {
        getData(currentPage)
    }, [])

    const getData = (page) => {
        setLoader(true)
        getPenaltybyPageSize(page, size, callback => {
            console.log("cal", callback)
            setLoader(false)
            if (callback?.status == "success") {
                setApiData(callback?.penaltyConfigList);
                setTotalItems(callback?.count)
            } else {
                setApiData([])
                setTotalItems(0)
            }

        });
    };


    const tableDatacheck = (data) => {
        if (data == null || data == undefined || data == '') {
            return '-'
        } else {
            return data
        }
    }
    const cancelLoanConfirm = (type) => {
        if (type == 'yes') {
            setLoader(true)
            DeletePenaltyconfigById(deleteData.id, (callback) => {
                setLoader(false)
                console.log("call", callback)
                if (callback == 'success') {
                    setPopupState(true)
                    setpopupStatus('Deleted successfully')
                    getData(1)
                    setcurrentPage(1)
                    setconfirmPopup(false)
                    setDeleteData({})
                } else {
                    setpopupStatus('Error')
                    setPopupState(true)
                }
                removePopup()
            })
        } else {
            setconfirmPopup(false)
            setDeleteData({})
        }
    }

    const handlePageChange = (event, value) => {
        setcurrentPage(value)
        getData(value)
    }

    const closePopup = () => {
        setPopupState(false)
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }



    return (
        <div className="projection-new">
            {
                loader ? <Loader /> : ""
            }
            {
                popupstate ?
                    <PopUp closePopup={closePopup} popupStatus={popupStatus} />
                    : ''}
            {
                confirmPopup ?
                    <ConfirmationPopup confirmationText={'Are You sure You Want To Delete This Utility'} cancelLoanConfirm={cancelLoanConfirm} />
                    : ''}
            {
                editMode == 'Editable' ?
                    <div className="Executor">
                        <AddEditLendor addType={addType} editData={editData} handleSavebtn={handleSavebtn} admin={admin} />
                    </div>
                    : ''}
            {
                editMode !== 'Editable' ?
                    <>
                        <button className='searchbtn btn btn-primary' style={{ marginTop: '20px', marginLeft: '20px' }} onClick={() => handlebtnclick('add', '')}><i class="fa fa-plus fa-lg" aria-hidden="true"></i></button>
                        <div className="container-fluid Executor" style={{ padding: '20px 10px', border: 'none' }}>
                            {
                                apiData && apiData?.length > 0 ?

                                    <div className='tableedit'>
                                        <div className="tableedit">
                                            <div className="phocket-table-new" style={{ overflowX: 'auto', marginTop: '0px', marginBottom: '30px' }}>
                                                <table style={{ marginBottom: '10px' }}>
                                                    <thead>
                                                        <tr>

                                                            <th>Min Loan Amount</th>
                                                            <th>Max Loan Amount</th>
                                                            <th>Slab Number</th>
                                                            <th>Penalty Value</th>
                                                            <th>Penalty Interest Rate</th>
                                                            <th>Bounce Charge</th>
                                                            <th>Created At</th>
                                                            <th>Updated At</th>


                                                            <th>Edit</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {apiData?.map((data, index) => (
                                                            <tr key={index}>

                                                                <td>{tableDatacheck(data.minLoan)}</td>
                                                                <td>{tableDatacheck(data.maxLoan)}</td>
                                                                <td>{tableDatacheck(data.slabNumber)}</td>
                                                                <td>{tableDatacheck(data.penaltyValue)}</td>
                                                                <td>{tableDatacheck(data.penaltyInterestRate)}</td>
                                                                <td>{tableDatacheck(data.bounceCharge)}</td>
                                                                <td>{moment(data?.createdAt)?.format("DD-MM-YYYY HH:MM:SS")}</td>
                                                                <td>{moment(data.updatedAt)?.format("DD-MM-YYYY HH:MM:SS")}</td>


                                                                <td>
                                                                    <div className='edits' style={{ display: 'flex', gap: '5px' }}>
                                                                        <i class="fa fa-pencil-square-o fa-lg" aria-hidden="true" onClick={() => handlebtnclick('edit', data)}></i>
                                                                        <i class="fa fa-trash-o fa-lg" aria-hidden="true" onClick={() => handlebtnclick('delete', data)}></i>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div style={{ float: 'right', marginTop: '20px' }}>
                                            <Pagination
                                                count={Math.ceil(totalItems / size)}
                                                page={currentPage}
                                                onChange={handlePageChange}
                                                color="primary"
                                            />
                                        </div>
                                    </div>
                                    :
                                    <p style={{ marginTop: '100px' }} className="text-center">
                                        <img src={Nodata} style={{ width: '30%' }} />
                                    </p>
                            }
                        </div>
                    </>
                    : ""}


        </div>
    )
}
export default Projections
